import {
  DestroyRef,
  Directive,
  effect,
  inject,
  input,
  output,
} from '@angular/core';

@Directive({
  selector: '[ngInit]',
  standalone: true,
})
export class SiaInitDirective {
  #destroyRef = inject(DestroyRef);

  isLast = input<boolean>(false);
  initEvent = output({ alias: 'ngInit' });

  #emitEffect = effect((onCleanup) => {
    this.isLast();

    const id = window.setTimeout(() => this.initEvent.emit(), 0);

    onCleanup(() => clearTimeout(id));
  });
}
